import { Navigate, Outlet } from 'react-router-dom'
import { hasAnyRole } from '@/features/accounts/utils'
import { useShallow } from 'zustand/react/shallow'
import {
  useAuthStore,
  selectRoles,
  selectIsSuperAdmin,
  type UserRole,
} from '../../stores/authStore'

interface RoleGuardProps {
  allowedRoles: UserRole[]
}

export function RoleGuard({ allowedRoles }: RoleGuardProps) {
  const roles = useAuthStore(useShallow(selectRoles))
  const isSuperAdmin = useAuthStore(selectIsSuperAdmin)

  if (!isSuperAdmin && !hasAnyRole(roles, allowedRoles)) {
    return <Navigate to='/unauthorized' replace />
  }
  return <Outlet />
}

export default RoleGuard
